import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '../../mui-styles-bridge.js';
import Dropzone from 'react-dropzone';

import { addPageData, deleteFileUpload } from '../../store/form/actions';
import Chip from '@mui/material/Chip';
import ErrorIcon from '@mui/icons-material/Error';
import CircularProgress from '@mui/material/CircularProgress';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import config from '../../config';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const styles = (theme) => ({
  checkbox: {
    color: '#afafaf',
    '&$checked': {
      color: '#2196F3',
    },
  },
  listtext: {},
  checked: {},
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
  dropzone: {
    border: '2px dashed #e0e0e0',
    borderRadius: '8px',
    padding: '48px 24px',
    textAlign: 'center',
    backgroundColor: '#fafafa',
    minHeight: '160px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: '#bdbdbd',
      backgroundColor: '#f5f5f5',
    },
  },
  dropzoneActive: {
    borderColor: '#9e9e9e',
    backgroundColor: '#f0f0f0',
    '& $uploadIcon': {
      color: '#757575',
    },
    '& $uploadText': {
      color: '#424242',
    },
  },
  uploadIcon: {
    fontSize: '40px',
    color: '#bdbdbd',
    marginBottom: '16px',
    transition: 'color 0.2s ease',
  },
  uploadText: {
    fontSize: '16px',
    color: '#666666',
    fontWeight: '500',
    marginBottom: '8px',
    transition: 'color 0.2s ease',
  },
  uploadSubtext: {
    fontSize: '14px',
    color: '#999999',
    fontWeight: '400',
  },
  sizeText: {
    color: '#757575',
    fontSize: '12px',
    marginTop: '16px',
    fontWeight: '400',
  },
  dropzoneLoading: {
    border: '2px dashed #e0e0e0',
    borderRadius: '8px',
    padding: '48px 24px',
    textAlign: 'center',
    backgroundColor: '#fafafa',
    minHeight: '160px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: '0.8',
  },
  loadingIcon: {
    color: '#bdbdbd',
    marginBottom: '16px',
  },
  loadingText: {
    fontSize: '16px',
    color: '#666666',
    fontWeight: '500',
    marginBottom: '8px',
  },
  loadingSubtext: {
    fontSize: '14px',
    color: '#999999',
    fontWeight: '400',
  },
  errorContainer: {
    backgroundColor: '#f5f5f5',
    padding: '12px 16px',
    marginTop: '16px',
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
  },
  errorIcon: {
    color: '#757575',
    marginRight: '8px',
    fontSize: '20px',
  },
  errorText: {
    margin: 0,
    fontSize: '14px',
    color: '#666666',
    fontWeight: '400',
  },
  chip: {
    backgroundColor: '#000',
    margin: '4px',
    height: '150px',
    minWidth: '200px',
    '& .MuiChip-deleteIcon': {
      margin: '8px',
      position: 'absolute',
      right: '0px',
      top: '1px',
    },
  },
  chipNotImage: {
    backgroundColor: '#000',
    margin: '4px',
    height: '90px',
    minWidth: '130px',
    '& .MuiChip-deleteIcon': {
      margin: '8px',
      position: 'absolute',
      right: '0px',
      top: '1px',
    },
  },
});

class UploadMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      upload_media: [],
      errorMessage: '',
      loading: false,
      isDragActive: false,
    };
  }
  componentWillUnmount() {
    this.state.upload_media.map((file, key) => {
      URL.revokeObjectURL(file.preview);
    });
  }
  componentDidMount() {
    let answer_data = this.props.form.answer_data[this.props.data.key];

    if (answer_data && answer_data.answer) {
      let files = this.props.form.answer_data[this.props.data.key].answer[0];

      let files_array = [];

      if (files instanceof Array) {
        files_array = [...files];
      } else {
        files_array.push(files);
      }

      this.setState({
        upload_media: files_array,
      });
    }
  }

  onFilesDrop = async (files) => {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      })
    );

    this.setState({
      loading: true,
    });

    let size = 0;

    for (let file of files) {
      size += file.size;

      if (size > config.UPLOAD_MEDIA_SIZE) {
        this.props.getDataFromComponent(
          { upload_media: this.state.upload_media },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );

        setTimeout(() => {
          this.setState({
            errorMessage:
              'File exceeds maximum size of ' +
              config.UPLOAD_MEDIA_SIZE / 1000000 +
              ' MB',
            upload_media: this.state.upload_media,
            loading: false,
          });
        }, 2000);
      } else {
        this.state.upload_media.push(file);

        this.props.getDataFromComponent(
          { upload_media: this.state.upload_media },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );

        setTimeout(() => {
          this.setState({
            errorMessage: '',
            upload_media: this.state.upload_media,
            loading: false,
          });
        }, 2000);
      }
    }
  };

  renderFileName = (uploadMedia) => {
    if (uploadMedia.name !== undefined) {
      return uploadMedia.name;
    } else {
      return uploadMedia;
    }
  };
  findLink = () => {
    //this will try to find the link from answer_data in case the form session is saved.
    if (
      this.props.form.answer_data !== undefined &&
      this.props.data.key !== undefined &&
      this.props.form.answer_data[this.props.data.key] !== undefined
    ) {
      let answer_data = this.props.form.answer_data[this.props.data.key];
      if (answer_data && answer_data.answer) {
        //the link returned will be the link to the zipped file
        // if more than one file is uploaded, so we don't have to
        // iterate through the whole answer.
        let file = this.props.form.answer_data[this.props.data.key].answer[0];
        return file.link;
      }
    }
  };

  removeItem = (key) => {
    let files = this.state.upload_media;
    files.splice(key, 1);

    this.setState({
      upload_media: files,
    });

    this.props.getDataFromComponent(
      { upload_media: this.state.upload_media },
      this.props.data.key,
      this.props.data.question_text,
      this.props.data.data
    );
  };

  render() {
    const { classes, form, data } = this.props;
    let accept_list = '';
    this.props.data.style.split(',').map((n) => {
      accept_list = accept_list + `.${n},`;
    });
    try {
      return (
        <div className={classes.root}>
          {!this.state.loading ? (
            <>
              <Dropzone
                style={{ width: '100%' }}
                multiple={true}
                disabled={this.props.data.read_only}
                onDrop={(acceptedFiles) => this.onFilesDrop(acceptedFiles)}
                onDragEnter={() => this.setState({ isDragActive: true })}
                onDragLeave={() => this.setState({ isDragActive: false })}
              >
                {({ getRootProps, getInputProps, isDragActive }) => (
                  <section>
                    <div {...getRootProps()}>
                      <div
                        className={`${classes.dropzone} ${
                          isDragActive ? classes.dropzoneActive : ''
                        }`}
                      >
                        <CloudUploadIcon className={classes.uploadIcon} />
                        <div className={classes.uploadText}>
                          {isDragActive
                            ? 'Drop files here'
                            : 'Drop files here to upload'}
                        </div>
                        <div className={classes.uploadSubtext}>
                          or click to browse
                        </div>
                      </div>
                      <input type="file" {...getInputProps()} />
                    </div>
                  </section>
                )}
              </Dropzone>
              <p className={classes.sizeText}>
                Maximum file size: {config.UPLOAD_MEDIA_SIZE / 1000000} MB
              </p>
              <div style={{ paddingTop: 8 }}>
                {this.state.upload_media.map((file, key) => {
                  return (
                    <Tooltip
                      title={this.renderFileName(file)}
                      placement={'top'}
                    >
                      <Chip
                        key={key}
                        avatar={
                          <Avatar
                            src={file.preview}
                            style={
                              file.type && file.type.includes('image')
                                ? {
                                    height: '100px',
                                    width: '170px',
                                    borderRadius: '4px',
                                    margin: '8px',
                                    position: 'absolute',
                                    top: '30px',
                                  }
                                : {
                                    height: '40px',
                                    width: '40px',
                                    borderRadius: '4px',
                                    margin: '8px',
                                    position: 'absolute',
                                    left: '0px',
                                    bottom: '1px',
                                  }
                            }
                          >
                            <img src="/svgs/fileIcon.svg" />
                          </Avatar>
                        }
                        className={
                          file.type && file.type.includes('image')
                            ? classes.chip
                            : classes.chipNotImage
                        }
                        label={
                          <>
                            <span
                              style={{
                                margin: '8px',
                                position: 'absolute',
                                left: '0px',
                                top: '1px',
                                maxWidth: '70%',
                                display: 'inline-block',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {this.renderFileName(file)}
                            </span>
                            {!this.props.data.read_only && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.removeItem(key);
                                }}
                                style={{
                                  position: 'absolute',
                                  right: '6px',
                                  top: '6px',
                                  background: 'white',
                                  border: 'none',
                                  cursor: 'pointer',
                                  color: '#59B0F6',
                                  padding: '4px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  borderRadius: '50%',
                                  width: '24px',
                                  height: '24px',
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </button>
                            )}
                          </>
                        }
                        onClick={() => {
                          if (file.name === undefined) {
                            window.open(file);
                          } else if (file.link) {
                            window.open(file.link);
                          } else {
                            let link = this.findLink();
                            if (link !== undefined) {
                              window.open(link);
                            }
                          }
                        }}
                        deleteIcon={null}
                        color="primary"
                      />
                    </Tooltip>
                  );
                })}
                {this.state.errorMessage && (
                  <div className={classes.errorContainer}>
                    <ErrorIcon className={classes.errorIcon} />
                    <p className={classes.errorText}>
                      {this.state.errorMessage}
                    </p>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <div className={classes.dropzoneLoading}>
                <CircularProgress size={40} className={classes.loadingIcon} />
                <div className={classes.loadingText}>Uploading files...</div>
                <div className={classes.loadingSubtext}>Please wait</div>
              </div>
              <p className={classes.sizeText}>
                Maximum file size: {config.UPLOAD_MEDIA_SIZE / 1000000} MB
              </p>
            </>
          )}
        </div>
      );
    } catch (e) {
      return <h5>Error encountered</h5>;
    }
  }
}

const mapStateToProps = (state, props) => {
  return {
    form: state.form,
  };
};

const mapDispatchToProps = {
  dispatchaddPageData: (key, answer, question_text) =>
    addPageData({ key, answer, question_text }),
  dispatchDeleteUpload: (key) => deleteFileUpload({ key }),
};

UploadMedia.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(UploadMedia));
